












import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import FilePreview from '@/components/file/FileGroupPreview.vue'
import { EventBus, FILE_REMOVED, FILE_RENAMED, FILE_UPLOADED } from '@/plugins/eventBus'

@Component({
  name: 'file-group-list',
  components: { FilePreview }
})
export default class FileGroupList extends Vue {
  fileGroups: FileGroup[] = []
  isLoading = true
  errorMessages: string[] = []

  @Prop()
  type: string;

  destroyed () {
    EventBus.$off(FILE_RENAMED)
    EventBus.$off(FILE_REMOVED)
    EventBus.$off(FILE_UPLOADED)
  }

  mounted () {
    EventBus.$on(FILE_RENAMED, ({ oldFileName, newFileName }) => {
      const fileGroup: FileGroup = this.fileGroups.find(_fileGroup => _fileGroup.name === oldFileName)
      fileGroup.name = newFileName
    })

    EventBus.$on(FILE_REMOVED, ({ fileName, fileId }) => {
      this.fileGroups = this.fileGroups.map(fileGroup => {
        if (fileGroup.name === fileName) {
          fileGroup.files = fileGroup.files.filter(file => file.fileId !== fileId)
        }
        return fileGroup
      })
    })

    EventBus.$on(FILE_UPLOADED, (file: IFile) => {
      let fileGroup: FileGroup = this.fileGroups.find(_fileGroup => _fileGroup.name === file.name)
      if (!fileGroup) {
        fileGroup = {
          name: file.name,
          txtime: file.txtime,
          files: [file]
        }
        this.fileGroups = [fileGroup, ...this.fileGroups]
      } else {
        fileGroup.files = [file, ...fileGroup.files]
        this.fileGroups = [fileGroup, ...this.fileGroups.filter(_fileGroup => _fileGroup.name !== fileGroup.name)]
      }
    })

    this.fetchFiles()
  }

  fetchFiles () {
    this.isLoading = true
    axiosInstance.get(`/files?type=${this.type}`)
      .then(resp => {
        this.fileGroups = resp.data
        // this.fileGroups = [{
        //   txtime: new Date().toISOString(),
        //   name: 'Haakkeo 2020-21 Kindergarten Naxay K3 Ceremony',
        //   files: [{
        //     txtime: new Date().toISOString(),
        //     fileId: 'FILEID1',
        //     description: 'Add 2 more students',
        //     uploader: 'Sithideth Bouasavanh'
        //   }, {
        //     txtime: new Date().toISOString(),
        //     fileId: 'FILEID2',
        //     description: 'Newly upload',
        //     uploader: 'Sithideth Bouasavanh'
        //   }]
        // }, {
        //   txtime: new Date().toISOString(),
        //   name: 'Haakkeo 2020-21 Kindergarten',
        //   files: [{
        //     txtime: new Date().toISOString(),
        //     fileId: 'FILEID3',
        //     description: 'Newly upload',
        //     uploader: 'Sithideth Bouasavanh'
        //   }]
        // }, {
        //   txtime: new Date().toISOString(),
        //   name: 'Haakkeo 2020-21 Kindergarten',
        //   files: [{
        //     txtime: new Date().toISOString(),
        //     fileId: 'FILEID3',
        //     description: 'Newly upload',
        //     uploader: 'Sithideth Bouasavanh'
        //   }]
        // }, {
        //   txtime: new Date().toISOString(),
        //   name: 'Haakkeo 2020-21 Kindergarten',
        //   files: [{
        //     txtime: new Date().toISOString(),
        //     fileId: 'FILEID3',
        //     description: 'Newly upload',
        //     uploader: 'Sithideth Bouasavanh'
        //   }]
        // }]
      })
      .catch(e => console.error(e))
      .finally(() => { this.isLoading = false })
  }

  @Watch('type')
  fileFiltered () {
    this.fetchFiles()
  }
}
